import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Reveal from "../components/Reveal";
import CTABanner from "../components/CTABanner";
import { IconChevron, IconArrow } from "../components/icons";
import { FAQS } from "../data";
import heroFaq from "../assets/images/hero/hero-faq.png";

export default function FAQ() {
  const navigate = useNavigate();
  const [openIdx, setOpenIdx] = useState(null);
  return (
    <main style={{ paddingTop: "var(--nav-h)" }}>
      {/* Hero */}
      <section className="sb-noise" style={{
        position: "relative", overflow: "hidden",
        backgroundImage: `url(${heroFaq})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        padding: "clamp(60px, 10vw, 100px) 0 clamp(48px, 8vw, 80px)", textAlign: "center",
      }}>
        <div style={{
          position: "absolute", inset: 0,
          background: "linear-gradient(160deg, rgba(58,24,68,0.75), rgba(80,30,60,0.68))",
          zIndex: 0,
        }} />
        <div className="sb-container" style={{ position: "relative", zIndex: 2 }}>
          <Reveal><span style={{ display: "inline-block", fontFamily: "var(--font-body)", fontWeight: 600, fontSize: "0.78rem", letterSpacing: "0.14em", textTransform: "uppercase", color: "var(--gold-light)", marginBottom: "12px" }}>FAQ</span></Reveal>
          <Reveal delay={0.1}><h1 style={{ color: "var(--white)", maxWidth: "600px", margin: "0 auto 16px" }}>Got <span style={{ color: "var(--gold)" }}>Questions?</span></h1></Reveal>
          <Reveal delay={0.15}><p style={{ color: "rgba(255,255,255,0.65)", maxWidth: "520px", margin: "0 auto", fontSize: "1.05rem" }}>Everything you need to know about booking, attending, and enjoying a Silly Butterfly experience.</p></Reveal>
        </div>
        <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, height: "80px", background: "linear-gradient(to top, var(--blush-tint), transparent)" }} />
      </section>

      {/* FAQ Accordion */}
      <section className="sb-section">
        <div className="sb-container" style={{ maxWidth: "780px" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            {FAQS.map((faq, i) => {
              const isOpen = openIdx === i;
              return (
                <Reveal key={i} delay={i * 0.04}>
                  <div style={{
                    background: "var(--white)", borderRadius: "var(--radius-md)",
                    boxShadow: "var(--shadow-sm)", border: isOpen ? "1px solid var(--gold)" : "1px solid rgba(212,168,83,0.08)",
                    overflow: "hidden", transition: "border-color 0.3s",
                  }}>
                    <button
                      onClick={() => setOpenIdx(isOpen ? null : i)}
                      style={{
                        width: "100%", background: "none", border: "none", cursor: "pointer",
                        padding: "20px 24px", display: "flex", alignItems: "center",
                        justifyContent: "space-between", gap: "16px", textAlign: "left",
                      }}
                    >
                      <span style={{
                        fontFamily: "var(--font-display)", fontWeight: 600, fontSize: "1.05rem",
                        color: isOpen ? "var(--gold)" : "var(--plum)", transition: "color 0.3s",
                      }}>
                        {faq.q}
                      </span>
                      <span style={{ color: isOpen ? "var(--gold)" : "var(--text-light)", flexShrink: 0 }}>
                        <IconChevron open={isOpen} />
                      </span>
                    </button>
                    <div style={{
                      maxHeight: isOpen ? "600px" : "0", overflow: "hidden",
                      transition: "max-height 0.5s ease",
                    }}>
                      <div style={{ padding: "0 24px 20px" }}>
                        {faq.a.split("\n\n").map((para, j, arr) => (
                          <p key={j} style={{ color: "var(--text-secondary)", lineHeight: 1.75, fontSize: "0.95rem", marginBottom: j < arr.length - 1 ? "12px" : 0 }}>{para}</p>
                        ))}
                      </div>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>

          <Reveal delay={0.3}>
            <div style={{
              textAlign: "center", marginTop: "48px", padding: "32px",
              background: "var(--blush-glow)", borderRadius: "var(--radius-lg)",
            }}>
              <h3 style={{ color: "var(--plum)", marginBottom: "10px" }}>Still have questions?</h3>
              <p style={{ color: "var(--text-secondary)", marginBottom: "24px" }}>
                Get in touch or request a quote and we will be delighted to guide you through the next steps.
              </p>
              <div style={{ display: "flex", gap: "12px", justifyContent: "center", flexWrap: "wrap" }}>
                <button className="sb-btn sb-btn-dark" onClick={() => { navigate("/contact"); window.scrollTo({ top: 0 }); }}>
                  Get in touch <IconArrow />
                </button>
                <button className="sb-btn sb-btn-outline" onClick={() => { navigate("/quote"); window.scrollTo({ top: 0 }); }}>
                  Request a quote <IconArrow />
                </button>
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      <CTABanner headline="Ready to Book?" sub="The hardest part is choosing your cocktails. We'll handle the rest." btnText="Start Planning" />
    </main>
  );
}
